{
  "tabs": {
    "chat": "Ćaskanje",
    "reminders": "Podsetnici",
    "calendar": "Kalendar",
    "settings": "Podešavanja"
  },
  "common": {
    "cancel": "Otkaži",
    "save": "Sačuvaj",
    "confirm": "Potvrdi",
    "delete": "Obriši",
    "back": "Nazad",
    "close": "Zatvori",
    "edit": "Izmeni",
    "search": "Pretraži",
    "all": "Sve",
    "loading": "Učitavanje...",
    "error": "Nešto je pošlo po zlu",
    "notFound": "Nije pronađeno",
    "tryAgain": "Pokušajte ponovo",
    "retry": "Pokušaj ponovo",
    "undo": "Poništi",
    "pullToRefresh": "Povući za osveženje",
    "justNow": "upravo sada"
  },
  "auth": {
    "welcome": "Dobrodošli u FishMemory",
    "tagline": "Vaš WhatsApp asistent za podsetnike, sada u vašem džepu.",
    "subtitle": "Vaš WhatsApp asistent za podsetnike, sada u vašem džepu.",
    "phoneLabel": "Vaš WhatsApp broj",
    "phoneHint": "Poslaćemo verifikacioni kod preko WhatsApp-a",
    "invalidPhone": "Unesite važeći broj telefona",
    "continue": "Nastavi",
    "enterPhone": "Unesite vaš WhatsApp broj",
    "phonePlaceholder": "Broj telefona",
    "sendCode": "Pošalji kod",
    "verifyTitle": "Potvrdite vaš broj",
    "otpSentTo": "6-cifreni kod je poslat na {{phone}} preko WhatsApp-a",
    "enterFullCode": "Unesite svih 6 cifara",
    "invalidOtp": "Nevažeći kod. Pokušajte ponovo.",
    "otpFailed": "Slanje koda nije uspelo. Pokušajte ponovo.",
    "otpResent": "Kod ponovo poslat",
    "resendIn": "Ponovo pošalji za {{seconds}}s",
    "resendCode": "Ponovo pošalji kod",
    "enterOtp": "Unesite kod poslat na vaš WhatsApp",
    "verify": "Potvrdi",
    "resend": "Ponovo pošalji kod",
    "wrongNumber": "Pogrešan broj?",
    "backToPhone": "Nazad na broj",
    "editPhone": "Izmeni broj telefona",
    "error": "Greška",
    "setupTitle": "Hajde da podesimo",
    "setupSubtitle": "Ovo uvek možete promeniti kasnije u Podešavanjima",
    "namePlaceholder": "Vaše ime",
    "letsGo": "Završi podešavanje",
    "skipForNow": "Preskoči za sada"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Kucajte poruku...",
    "inputPlaceholder": "Kucajte poruku...",
    "typing": "FishMemory kuca...",
    "online": "Na mreži",
    "connecting": "Povezivanje...",
    "reconnecting": "Ponovno povezivanje...",
    "offline": "Van mreže",
    "empty": "Započni razgovor",
    "emptyHint": "Kreirajte podsetnike, proverite raspored ili zatražite pomoć.",
    "emptyAction": "Pošalji primer podsetnika",
    "actions": "Akcije ćaskanja",
    "keep": "Zadrži poruke",
    "clearTitle": "Obriši ćaskanje",
    "clearConfirm": "Obrisati sve poruke sa ovog uređaja? Ovo se ne može poništiti.",
    "clear": "Obriši ćaskanje",
    "optionSelected": "Izabrano: {{label}}",
    "sendingSelection": "Šalje se...",
    "connectionLost": "Ponovno povezivanje..."
  },
  "reminders": {
    "title": "Moji podsetnici",
    "active": "Aktivni",
    "today": "Danas",
    "thisWeek": "Ove nedelje",
    "history": "Istorija",
    "items": "stavki",
    "emptyTitle": "Još nema podsetnika",
    "emptySubtitle": "Kreirajte jedan u ćaskanju i pojaviće se ovde.",
    "emptyAction": "Otvori ćaskanje",
    "filterActive": "Aktivni",
    "filterToday": "Danas",
    "filterWeek": "Ove nedelje",
    "filterHistory": "Istorija",
    "emptyState": "Još nema podsetnika. Počnite ćaskanje!",
    "swipeDone": "Gotovo",
    "swipeSnooze": "Odgodi",
    "swipeDelete": "Obriši",
    "search": "Pretraži podsetnike...",
    "upcoming": "Predstojeći",
    "completed": "Završeni",
    "overdue": "Istekli",
    "tomorrow": "Sutra",
    "synced": "Sinhronizovano {{value}}",
    "swipeHint": "Prevucite podsetnik za više opcija",
    "noResults": "Nema podsetnika koji odgovaraju pretrazi",
    "noResultsHint": "Pokušajte drugu ključnu reč ili očistite pretragu",
    "deleteAllFailed": "Brisanje svih podsetnika nije uspelo"
  },
  "calendar": {
    "title": "Kalendar",
    "today": "Danas",
    "tomorrow": "Sutra",
    "completed": "završeno",
    "noEvents": "Nema događaja",
    "noEventsSubtitle": "Izaberite datum da vidite podsetnike i događaje iz kalendara.",
    "googleEvent": "Google Kalendar",
    "legendActive": "Aktivni",
    "legendRecurring": "Ponavljajući",
    "legendDone": "Završeni",
    "legendGoogle": "Google",
    "previousMonth": "Prethodni mesec",
    "nextMonth": "Sledeći mesec",
    "previousYear": "Prethodna godina",
    "nextYear": "Sledeća godina",
    "goToToday": "Idi na danas",
    "all": "Sve",
    "active": "Aktivni",
    "done": "Završeni",
    "paused": "Pauzirano"
  },
  "settings": {
    "title": "Podešavanja",
    "profile": "Profil",
    "name": "Ime za prikaz",
    "enterName": "Unesite ime",
    "language": "Jezik",
    "uiLanguage": "Jezik aplikacije",
    "uiLanguageHelp": "Menja jezik interfejsa, oznake kalendara i pravac rasporeda samo na ovom uređaju.",
    "serverLanguage": "Jezik ćaskanja",
    "serverLanguageHelp": "Menja jezik odgovora servera i poruka podsetnika za vaš nalog.",
    "timezone": "Vremenska zona",
    "currentTimezone": "Trenutna vremenska zona",
    "timezoneHelp": "Sva vremena podsetnika prikazuju se u ovoj vremenskoj zoni.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Sačuvaj vremensku zonu",
    "timezoneSaved": "Vremenska zona ažurirana",
    "detect": "Detektuj",
    "detectFailed": "Nije moguće detektovati vremensku zonu",
    "autoDetect": "Automatski sa GPS-a",
    "notifications": "Obaveštenja",
    "notificationsHelp": "Podsetnici za praćenje kontrolišu ponovljene alarme nakon što je podsetnik isporučen. Dozvole za obaveštenja na uređaju se i dalje podešavaju u podešavanjima telefona.",
    "pushEnabled": "Push obaveštenja",
    "autoDoneOnFire": "Automatski označi kao završeno kada se aktivira",
    "autoDoneOnFireDesc": "Kada je isključeno, podsetnici ostaju aktivni dok ih ne označite kao završene.",
    "googleCalendar": "Google Kalendar",
    "google": "Google Kalendar",
    "googleConnected": "Povezano",
    "googleDisconnected": "Nije povezano",
    "googleConnectedHelp": "Novi podsetnici mogu se automatski sinhronizovati sa vašim kalendarom.",
    "googleDisconnectedHelp": "Povežite Google Kalendar da biste uskladili podsetnike i događaje.",
    "googleConnectFailed": "Povezivanje sa Google Kalendarom nije uspelo",
    "connected": "Povezano",
    "disconnected": "Nije povezano",
    "connect": "Poveži",
    "disconnect": "Prekini vezu",
    "autoSync": "Automatska sinhronizacija novih podsetnika",
    "autosync": "Automatska sinhronizacija novih podsetnika",
    "subscription": "Pretplata",
    "trialUsed": "Probni period: {{used}}/{{total}} iskorišćeno",
    "trialStatus": "Probni period dostupan",
    "activeStatus": "Aktivna pretplata",
    "expiredStatus": "Pretplata istekla",
    "unsubscribedStatus": "Nema pretplate",
    "about": "O aplikaciji",
    "version": "Verzija",
    "logout": "Odjavi se",
    "logoutTitle": "Odjavi se",
    "logoutConfirm": "Da li ste sigurni da želite da se odjavite?",
    "noName": "Ime nije postavljeno",
    "serverConnection": "Veza sa serverom",
    "serverUrl": "URL servera",
    "serverEdit": "Izmeni",
    "saveReconnect": "Sačuvaj i ponovo poveži",
    "resetDefault": "Vrati podrazumevano",
    "invalidServerUrlTitle": "Nevažeći URL servera",
    "invalidServerUrlMessage": "Unesite važeći http ili https URL servera, na primer https://example.com",
    "uiLanguageChangeFailed": "Promena jezika aplikacije nije uspela. Pokušajte ponovo.",
    "serverLanguageChangeFailed": "Promena jezika ćaskanja nije uspela. Pokušajte ponovo.",
    "timezoneChangeFailed": "Promena vremenske zone nije uspela. Pokušajte ponovo.",
    "autoSyncChangeFailed": "Ažuriranje automatske sinhronizacije nije uspelo. Pokušajte ponovo.",
    "nameChangeFailed": "Ažuriranje imena za prikaz nije uspelo. Pokušajte ponovo.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Detalji podsetnika",
    "editTime": "Izmeni vreme",
    "rename": "Preimenuj",
    "snooze": "Odgodi",
    "snooze15": "Odgodi 15 minuta",
    "pause": "Pauziraj",
    "pauseReminder": "Pauziraj podsetnik",
    "resume": "Nastavi",
    "resumeReminder": "Nastavi podsetnik",
    "skip": "Preskoči sledeći",
    "skipOccurrence": "Preskoči ovu pojavu",
    "syncGoogle": "Sinhronizuj sa Google",
    "delete": "Obriši",
    "deleteTitle": "Obriši podsetnik",
    "deleteConfirm": "Ovaj podsetnik će biti trajno obrisan.",
    "deleteRecurringTitle": "Obriši ponavljajući podsetnik",
    "deleteRecurringMessage": "Da li želite da preskočite ovu pojavu ili obrišete celu seriju?",
    "deleteThisOccurrence": "Preskoči ovu pojavu",
    "deleteEntireSeries": "Obriši celu seriju",
    "done": "Završeno",
    "markDone": "Označi kao završeno",
    "undo": "Vrati",
    "undoPrompt": "Treba vam ponovo aktivan? Vratite ga sada.",
    "recurring": "Ponavljajući",
    "nextRun": "Sledeće izvršenje",
    "oneTime": "Jednokratni",
    "pending": "Na čekanju",
    "sent": "Poslato",
    "paused": "Pauzirano",
    "active": "Aktivno",
    "snoozed": "Odgodjeno",
    "localTime": "Prikazano u vašem lokalnom vremenu",
    "recurrence": "Ponavljanje",
    "created": "Kreirano",
    "tags": "Oznake",
    "fireCount": "Broj aktiviranja",
    "actions": "Akcije",
    "none": "Nema",
    "snoozeFailed": "Odgoda podsetnika nije uspela",
    "pauseFailed": "Pauziranje podsetnika nije uspelo",
    "resumeFailed": "Nastavak podsetnika nije uspeo",
    "skipFailed": "Preskakanje podsetnika nije uspelo",
    "doneFailed": "Označavanje podsetnika kao završenog nije uspelo",
    "undoFailed": "Vraćanje statusa podsetnika nije uspelo",
    "deleteFailed": "Brisanje podsetnika nije uspelo",
    "rescheduleTitle": "Prezakazati?",
    "rescheduleMsg": "Ovaj podsetnik je istekao. Da li želite da ga prezakazate?",
    "reschedule15": "Za 15 minuta",
    "reschedule60": "Za 1 sat",
    "keepOverdue": "Ostavi kako jeste"
  },
  "onboarding": {
    "slide1Title": "Dobrodošli u FishMemory",
    "slide1Sub": "Vaš lični asistent za podsetnike — pokretan WhatsApp-om i napravljen za vaš džep.",
    "slide2Title": "Samo ćaskajte prirodno",
    "slide2Sub": "Kucajte podsetnike onako kako mislite: \"Podseti me da pozovem mamu sutra u 15h\" — mi ćemo se pobrinuti za ostalo.",
    "slide3Title": "Nikad ništa ne propustite",
    "slide3Sub": "Dobijajte pravovremena obaveštenja, organizujte sa oznakama i budite u toku sa svime što vam je važno.",
    "getStarted": "Počnimo",
    "next": "Dalje",
    "firstReminderTitle": "Kreirajte svoj prvi podsetnik!",
    "firstReminderHint": "Pokušajte da ukucate nešto poput:",
    "firstReminderExample": "Podseti me da pijem vodu sutra u 9 ujutru",
    "gotIt": "Razumem!",
    "notifRationaleTitle": "Budite na vreme",
    "notifRationaleBody": "FishMemory treba obaveštenja da vas podseća na vreme. Dobijaćete obaveštenja samo za podsetnike koje kreirate.",
    "notifRationaleAllow": "Omogući obaveštenja",
    "notifRationaleLater": "Možda kasnije",
    "swipeHint": "Prevucite desno za brze akcije →",
    "calendarDragHint": "Prevucite da proširite ↕"
  }
}
